import { get, post, put, destroy } from './APIClient';

module.exports = {
  updatePage,
  getPage,
  getPublicPage,
  getAnalytics,
};

function updatePage({ workspaceId, booster }) {
  return put(`/workspaces/${workspaceId}/review-booster`, booster);
}

async function getPublicPage({ publicId, visitorHeaders }) {
  if(!publicId) {
    return;
  }
  const config = {};
  if(visitorHeaders) {
    config.headers = Object.fromEntries(Object.entries(visitorHeaders).filter(([, value]) => value));
  }
  const res = await get(`/booster/${publicId}`, config);
  if(res.error) {
    throw res.error;
  }
  return res?.data || {};
}

async function getAnalytics({ workspaceId, startDate, endDate }) {
  const res = await get(`/workspaces/${workspaceId}/review-booster/analytics`, { params: { startDate, endDate } });
  if(res.error) {
    throw res.error;
  }
  return res?.data || {};
}

async function getPage(url) {
  const res = await get(url);
  if(res.error) {
    throw res.error;
  }
  return _.get(res, 'data', {});
}
